import { render, staticRenderFns } from "./Boundary.vue?vue&type=template&id=3c2f2a86"
import script from "./Boundary.vue?vue&type=script&setup=true&lang=js"
export * from "./Boundary.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Boundary.vue?vue&type=style&index=0&id=3c2f2a86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports